import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import Checkbox from "../../common/Checkbox";
import Pagination from "../../common/TablePagination";
import closeIcon from "../../../Assets/Icons/popupCloseIcon.svg";
import whiteTick from "../../../Assets/Icons/White Tick.svg";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import DeleteConfirmationModal from "../../common/DeleteConfirmationModal";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedWhiteBox.svg";
import { ReactComponent as UncheckedGreyIcon } from "../../../Assets/Icons/unCheckedGreyIcon.svg";
import Loader from "../../common/Loader";
import DetailsPopup from "../../common/DetailsPopup";
import infoIcon from "../../../Assets/Icons/infoIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../../common/SearchBar";
import debounce from "lodash.debounce";
import { Dropdown, Drawer } from "antd";
import FilterPanel from "../../common/FilterPanel";
import DetailsModal from "../../common/DetailsModal";
import RejectOfferPopup from "../../common/RejectOfferPopup";
import crossIcon from "../../../Assets/Icons/cross.svg";
import AddNewLocation from "../../common/OfferForm/Location/AddNewLocation";
import UploadCSVDrawer from "../../common/OfferForm/Location/UploadCSVDrawer";
import { ReactComponent as BackArrow } from "../../../Assets/Icons/backWhiteIcon.svg";
import {
  addFranchise,
  getFranchises,
} from "../../../services/franchiseService";
import toast from "../../../utils/toast";
import "../../common/OfferForm/offerform.scss";
import {
  hasUserAccount,
  normalizeStatus,
} from "../../../utils/merchantRecordUtils";
import {
  getMerchants,
  toggleMerchantStatus,
  getMerchantById,
  approveOrRejectMerchant,
} from "../../../services/merchantService";
import { deleteMerchantAdmin } from "../../../services/adminService";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import PopupContent from "./AdminMerchantDetailsPopupContent";
import CancelPopup from "../../common/CancelPopup";
import { DatePicker } from "antd";
import Confirmation from "../../common/OfferList/Confirmation";
import AddIcon from "../../../Assets/Icons/AddIcon.svg";
import FilterButton from "../../common/FilterButton";
import ChangeLogoModal from "./ChangeLogoModal";
import EditMerchantModal from "./EditMerchantModal";
import TableEmptyState from "../../common/TableEmptyState";
import ActiveFilterBar from "../../common/ActiveFilterBar";
import { Drawer as MuiDrawer } from "@mui/material";
import { formatCustomDateRangeLabel } from "../../../utils/filterLabelUtils";
import TruncatedTableCell from "../../common/TruncatedTableCell";

const getMerchantStatusActionLabel = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "approved" || normalized === "live") return "Live";
  if (
    normalized === "disabled" ||
    normalized === "declined" ||
    normalized === "rejected"
  )
    return "Disable";
  if (normalized === "deleted") return "Delete";
  if (normalized === "pending") return "Pending";

  return "Change status";
};

const getMerchantStatusResultLabel = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "approved" || normalized === "live") return "Live";
  if (
    normalized === "disabled" ||
    normalized === "declined" ||
    normalized === "rejected"
  )
    return "Disabled";
  if (normalized === "deleted") return "Deleted";
  if (normalized === "pending") return "Pending";

  return "Updated";
};

// Remove RangePicker and use DatePicker instead for better fit
// const { RangePicker } = DatePicker;

const AdminMerchantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loading = useSelector((state) => state?.merchantReducer?.loading);
  const fundraiserLoading = useSelector(
    (state) => state?.fundraiserReducer?.loading,
  );

  const [fullMerchantsList, setFullMerchantsList] = useState([]);
  const [displayedMerchants, setDisplayedMerchants] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [clickedOffer, setClickedOffer] = useState(null);
  const [reason, setReason] = useState("");
  const [infoClicked, setInfoClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [statusToggled, setStatusToggled] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [openReasonBox, setOpenReasonBox] = useState(false);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [isMerchantDetailOpen, setIsMerchantDetailOpen] = useState(false);
  const [showApprovalConfirm, setShowApprovalConfirm] = useState(false);
  const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [merchantToDelete, setMerchantToDelete] = useState(null);
  const [customDate, setCustomDate] = useState([null, null]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showChangeLogoModal, setShowChangeLogoModal] = useState(false);
  const [merchantForLogoChange, setMerchantForLogoChange] = useState(null);
  const [showEditMerchantModal, setShowEditMerchantModal] = useState(false);
  const [merchantForEdit, setMerchantForEdit] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showStatusConfirm, setShowStatusConfirm] = useState(false);
  const [statusChangeLoading, setStatusChangeLoading] = useState(false);
  const statusMutationLockRef = useRef(false);
  const [targetStatus, setTargetStatus] = useState(null);
  const [statusChangeTargetMerchant, setStatusChangeTargetMerchant] =
    useState(null);
  const [offerCount, setOfferCount] = useState(0);
  // Track manual status changes to force them to the top of the list immediately
  const [manualSortMap, setManualSortMap] = useState(() => {
    try {
      const saved = localStorage.getItem("merchantManualSortMap");
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  // Persist manual sort map to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(
      "merchantManualSortMap",
      JSON.stringify(manualSortMap),
    );
  }, [manualSortMap]);
  const [activeMerchantId, setActiveMerchantId] = useState(null);
  const [addClicked, setAddClicked] = useState(false);
  const [csvDrawerOpen, setCsvDrawerOpen] = useState(false);
  const [csvLocations, setCsvLocations] = useState([]);
  const [selectedCsvLocationIds, setSelectedCsvLocationIds] = useState([]);
  const [locationToEdit, setLocationToEdit] = useState(null);
  const [isCsvSubmitting, setIsCsvSubmitting] = useState(false);
  const pendingMerchantModalId = location?.state?.openMerchantId;

  const [filterParams, setFilterParams] = useState({
    status: "live",
    duration: null,
    startDate: null,
    endDate: null,
  });

  // Add these mappings
  const DURATION_MAP = {
    Today: "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };

  const [filterData, setFilterData] = useState([
    {
      id: "status",
      title: "Status",
      options: ["Live", "In-Progress", "Disabled", "Deleted"],
      defaultValue: "Live",
      multiSelect: false,
      valueMap: {
        Live: "live",
        "In-Progress": "in_progress",
        Disabled: "disabled",
        Deleted: "deleted",
      },
    },
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: null,
      multiSelect: false,
      valueMap: DURATION_MAP,
      customContent: (selected, filterParams) => {
        console.log("Custom Date selected value:", selected);
        return selected === "Custom Date" ? (
          <div
            className="mt-3 flex flex-col gap-2"
            style={{ pointerEvents: "auto", zIndex: 10000 }}
          >
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">
                Start Date
              </label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  console.log("Start date changed:", date);
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: "100%", pointerEvents: "auto" }}
                className="custom-date-picker"
                placeholder="Select Start Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">
                End Date
              </label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  console.log("End date changed:", date);
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: "100%", pointerEvents: "auto" }}
                className="custom-date-picker"
                placeholder="Select End Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
          </div>
        ) : null;
      },
    },
  ]);

  // Fix: Update filterData when customDate changes to avoid stale closures
  useEffect(() => {
    setFilterData((prevData) =>
      prevData.map((filter) => {
        if (filter.id === "duration") {
          return {
            ...filter,
            customContent: (selected, filterParams) => {
              console.log("Custom Date selected value:", selected);
              return selected === "Custom Date" ? (
                <div
                  className="mt-3 flex flex-col gap-2"
                  style={{ pointerEvents: "auto", zIndex: 10000 }}
                >
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">
                      Start Date
                    </label>
                    <DatePicker
                      value={customDate?.[0]}
                      onChange={(date) => {
                        console.log("Start date changed:", date);
                        const newDates = [date, customDate?.[1]];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: "100%", pointerEvents: "auto" }}
                      className="custom-date-picker"
                      placeholder="Select Start Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">
                      End Date
                    </label>
                    <DatePicker
                      value={customDate?.[1]}
                      onChange={(date) => {
                        console.log("End date changed:", date);
                        const newDates = [customDate?.[0], date];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: "100%", pointerEvents: "auto" }}
                      className="custom-date-picker"
                      placeholder="Select End Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                </div>
              ) : null;
            },
          };
        }
        return filter;
      }),
    );
  }, [customDate]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue ?? null;
      }
      return acc;
    }, {});
  };

  const createClearedState = (filters) => {
    return filters.reduce((acc, filter) => {
      acc[filter.id] = filter.multiSelect ? [] : null;
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(() =>
    createInitialState(filterData),
  );

  // Update the handleSelectionChange function
  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));

    if (filterId === "duration" && value !== "CUSTOM") {
      setCustomDate([null, null]);
    }
  };

  // 1. Chips derivation from SELECTIONS (for immediate feedback)
  const activeFilterChips = useMemo(() => {
    const chips = [];
    Object.entries(filterParams).forEach(([key, value]) => {
      if (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      )
        return;
      if (value === "") return;

      const filter = filterData.find((f) => f.id === key);
      if (!filter) return;

      if (filter.multiSelect && Array.isArray(value)) {
        value.forEach((val) => {
          const displayLabel =
            Object.keys(filter.valueMap || {}).find(
              (k) => filter.valueMap[k] === val,
            ) || val;
          chips.push({ id: key, value: val, label: `${displayLabel}` });
        });
      } else {
        const displayLabel =
          Object.keys(filter.valueMap || {}).find(
            (k) => filter.valueMap[k] === value,
          ) || value;
        chips.push({ id: key, value: value, label: `${displayLabel}` });
      }
    });

    // Special handling for custom date range label
    if (filterParams.duration === "CUSTOM") {
      const dChip = chips.find((c) => c.id === "duration");
      if (dChip) {
        dChip.label = formatCustomDateRangeLabel(
          filterParams.startDate || customDate?.[0],
          filterParams.endDate || customDate?.[1],
        );
      }
    }

    return chips;
  }, [filterParams, filterData, customDate]);

  const activeCount = activeFilterChips.length;
  const isMerchantCustomDateIncomplete =
    selections?.duration === "Custom Date" &&
    (!customDate?.[0] || !customDate?.[1]);

  const applyFilters = (sels) => {
    const mappedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };

    filterData.forEach((filter) => {
      const selectedValue = sels[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "CUSTOM") {
          mappedFilterParams.duration = "CUSTOM";
          if (customDate && (customDate[0] || customDate[1])) {
            mappedFilterParams.startDate = customDate[0]
              ? customDate[0].format("YYYY-MM-DD")
              : null;
            mappedFilterParams.endDate = customDate[1]
              ? customDate[1].format("YYYY-MM-DD")
              : null;
          }
        } else if (filter.valueMap) {
          const mappedValue = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
          // Only set the value if it's not null (i.e., not "All")
          if (mappedValue !== null) {
            mappedFilterParams[filter.id] = mappedValue;
          }
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });

    setFilterParams(mappedFilterParams);
    setCurrentPage(1);
    return mappedFilterParams;
  };

  const handleApply = () => {
    setCurrentPage(1);
    const mappedFilterParams = applyFilters(selections);
    getMerchantsData(searchQuery, false, false, mappedFilterParams);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleReset = () => {
    const clearedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };
    setSelections(createClearedState(filterData));
    setFilterParams(clearedFilterParams);
    setCustomDate([null, null]);
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
    getMerchantsData("", false, false, clearedFilterParams);
  };

  const handleRemoveFilter = (targetChip) => {
    const filter = filterData.find((f) => f.id === targetChip.id);
    if (!filter) return;

    let newValue;
    if (filter.multiSelect) {
      newValue = selections[targetChip.id].filter(
        (v) => v !== targetChip.value,
      );
    } else {
      newValue = null;
    }

    const newSelections = { ...selections, [targetChip.id]: newValue };
    setSelections(newSelections);

    if (targetChip.id === "duration" && newValue === null) {
      setCustomDate([null, null]);
    }

    const mappedFilterParams = applyFilters(newSelections);
    getMerchantsData(searchQuery, false, false, mappedFilterParams);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("dropdown-open");
    } else {
      document.body.classList.remove("dropdown-open");
    }

    return () => {
      document.body.classList.remove("dropdown-open");
    };
  }, [open]);

  const items = [
    {
      title: "Merchants",
    },
    {
      title: "Merchant List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Name",
    },
    {
      name: "Date joined",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Address",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const isInProcess = (merchant) => {
    const status = (merchant?.status || "").toLowerCase();
    // If status is explicitly "in_progress", consider it as In-Process
    if (status === "in_progress") {
      return true;
    }

    // A merchant is only considered "In-Process" in the Merchant List if they have actually
    // started their onboarding (has a user account or entered business details).
    // Otherwise, they stay in the Invitation List.
    const hasStarted =
      !!merchant.userId ||
      !!merchant.user ||
      !!merchant.businessName ||
      !!merchant.business_name;
    const inProcessStatuses = [
      "pending",
      "accepted",
      "completed",
      "in-process",
      "in-progress",
    ];

    if (status === "pending" || status === "") {
      return hasStarted;
    }

    return inProcessStatuses.includes(status);
  };

  const matchesMerchantStatusFilter = (merchant, statusFilter) => {
    const normalizedFilter = normalizeStatus(statusFilter);
    if (!normalizedFilter) return true;

    const merchantStatus = normalizeStatus(merchant?.status);

    if (normalizedFilter === "live") {
      return ["approved", "live"].includes(merchantStatus);
    }

    if (normalizedFilter === "in-progress") {
      return isInProcess(merchant);
    }

    if (normalizedFilter === "disabled") {
      return ["disabled", "declined", "rejected"].includes(merchantStatus);
    }

    if (normalizedFilter === "deleted") {
      return merchantStatus === "deleted";
    }

    return true;
  };

  const updatePageSlice = (data, page) => {
    if (!data) return;
    const startIndex = (page - 1) * 10;
    const endIndex = startIndex + 10;
    setDisplayedMerchants(data.slice(startIndex, endIndex));
  };

  const getMerchantRecordId = (merchant) =>
    merchant?._id || merchant?.id || merchant?.userId || merchant?.user?._id;

  const removePlaceholderMerchants = (merchants = []) =>
    merchants.filter((merchant) => {
      const name = merchant?.businessName || merchant?.business_name || "";
      return typeof name === "string" && !name.startsWith("Pending_");
    });

  const matchesMerchantSearch = (merchant, searchTerm) => {
    const normalizedTerm = searchTerm?.trim().toLowerCase();
    if (!normalizedTerm) return true;

    const searchableValues = [
      merchant?.businessName,
      merchant?.business_name,
      merchant?.user?.email,
      merchant?.email,
      merchant?.address,
      merchant?.businessAddress,
      merchant?.storeAddress,
      merchant?.contactPersonNumber,
      merchant?.contactNumber,
      merchant?.phone,
      merchant?.name,
    ]
      .filter(Boolean)
      .map((value) => String(value).toLowerCase());

    return searchableValues.some((value) => value.includes(normalizedTerm));
  };

  const getMerchantsData = async (
    searchValue = searchQuery,
    silent = false,
    ignoreStatus = false,
    filterOverride = null,
  ) => {
    try {
      if (silent) setSearching(true);
      const activeFilters = filterOverride || filterParams;
      const isCustomDuration = activeFilters?.duration === "CUSTOM";
      const requestStartDate =
        isCustomDuration && customDate?.[0]
          ? customDate[0].format("YYYY-MM-DD")
          : activeFilters?.startDate || null;
      const requestEndDate =
        isCustomDuration && customDate?.[1]
          ? customDate[1].format("YYYY-MM-DD")
          : activeFilters?.endDate || null;
      let searchParams = {
        limit: 500,
        ...(activeFilters?.duration && { duration: activeFilters.duration }),
        ...(requestStartDate && { startDate: requestStartDate }),
        ...(requestEndDate && { endDate: requestEndDate }),
        ...(!ignoreStatus &&
          activeFilters?.status && { status: activeFilters.status }),
        // NOTE: Never send status to the API — the backend uses different status values
        // ("approved" not "live", "declined"/"disabled" not "disabled").
        // All status filtering is handled client-side in the useEffect below.
        silent: silent,
      };

      // Remove null values to avoid sending empty parameters
      Object.keys(searchParams).forEach((key) =>
        searchParams[key] === null ? delete searchParams[key] : {},
      );

      const response = await dispatch(getMerchants(searchParams))?.unwrap();
      if (response?.success) {
        setFullMerchantsList(removePlaceholderMerchants(response.data || []));
      }
    } catch (error) {
      console.error("Error in getMerchantsData:", error);
    } finally {
      setSearching(false);
    }
  };

  // 1. Initial/Status load
  useEffect(() => {
    getMerchantsData();
  }, [statusToggled]);

  // Logic to filter and slice data for display
  useEffect(() => {
    if (!fullMerchantsList) return;

    const filtered = [...fullMerchantsList]
      .filter((merchant) => hasUserAccount(merchant))
      .filter((merchant) =>
        matchesMerchantStatusFilter(merchant, filterParams.status),
      )
      .filter((merchant) => matchesMerchantSearch(merchant, searchQuery));

    const nextTotalPages = Math.ceil(filtered.length / 10) || 1;
    const nextPage = Math.min(currentPage, nextTotalPages);

    setCount(filtered.length);
    setTotalPages(nextTotalPages);

    if (nextPage !== currentPage) {
      setCurrentPage(nextPage);
    }

    updatePageSlice(filtered, nextPage);
  }, [fullMerchantsList, currentPage, searchQuery, filterParams]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of merchant list when changing pages
    const container = document.getElementById("merchant-list-container");
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // const handleToggle = async (id) => {
  //   try {
  //     const togglePromise = await dispatch(
  //       toggleOfferStatus({ id: id })
  //     ).unwrap();
  //     if (togglePromise?.success === true) {
  //       getOffersData();
  //     }
  //   } catch (error) {
  //     console.error("Error toggling location status:", error);
  //   }
  // };

  const handleCloseInfo = () => {
    setInfoClicked(false);
    setClickedOffer(null);
  };

  const handleInfoClick = (offer) => {
    setClickedOffer(offer);
    setInfoClicked(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchQuery(value);
        setCurrentPage(1);
        setSearching(false);
      }, 500),
    [],
  );

  const handleSearchChange = (value) => {
    setSearchInput(value);
    debouncedSearch.cancel();

    if (!value.trim()) {
      setSearchQuery("");
      setCurrentPage(1);
      setSearching(false);
      return;
    }

    debouncedSearch(value);
  };

  const getSelectableOffers = () => {
    return fullMerchantsList || [];
  };

  const handleSelectAll = () => {
    const selectableOffers = getSelectableOffers();

    if (
      selectableOffers.length > 0 &&
      selected.length === selectableOffers.length
    ) {
      setSelected([]);
    } else {
      const newSelected = selectableOffers.map((offer) => offer._id);
      setSelected(newSelected);
    }
  };

  const handleSelectOne = (event, id, status) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Allow selection for all statuses (Approved/Declined can be moved to Pending)
  const isSelectable = (status) => {
    return true;
  };

  const handleBulkApprove = () => {
    setShowApprovalConfirm(true);
  };

  const handleApproveConfirm = async () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    setShowApprovalConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "live",
        silent: true,
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[id] = timestamp;
        });
        setManualSortMap(newSortMap);
        setStatusToggled(!statusToggled);
        setSelected([]);
        toast.success(`${selected.length} merchant(s) approved successfully!`);
      }
    } catch (error) {
      console.error("Error approving offers:", error);
      toast.error("Failed to approve merchants.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleBulkDecline = () => {
    setShowDeclineConfirm(true);
  };

  const handleDeclineConfirm = async () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    setShowDeclineConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "disabled",
        reason: "Bulk declined",
        silent: true,
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[id] = timestamp;
        });
        setManualSortMap(newSortMap);
        setStatusToggled(!statusToggled);
        setSelected([]);
        toast.success(`${selected.length} merchant(s) disabled successfully!`);
      }
    } catch (error) {
      console.error("Error declining offers:", error);
      toast.error("Failed to disable merchants.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  // Move selected merchants to pending
  const handleBulkPending = async () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const payload = {
        ids: selected,
        status: "pending",
        reason: "Moved to pending",
        silent: true,
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[id] = timestamp;
        });
        setManualSortMap(newSortMap);
        setStatusToggled(!statusToggled);
        setSelected([]);
        setShowActionModal(false);
        toast.success(
          `${selected.length} merchant(s) moved to In-Progress successfully!`,
        );
      }
    } catch (error) {
      console.error("Error setting pending merchants:", error);
      toast.error("Failed to move merchants to In-Progress.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  // Single approve/decline from detail modal
  const handleApproveSingle = async (id) => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const payload = { ids: [id], status: "live", silent: true };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        setFullMerchantsList((prev) =>
          prev.map((m) =>
            m._id === id || m.id === id ? { ...m, status: "live" } : m,
          ),
        );
        setManualSortMap((prev) => ({ ...prev, [id]: Date.now() }));
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false); // Close modal
        setMerchantDetails(null); // Clear details
        toast.success("Merchant status changed to Live successfully!");
      }
    } catch (e) {
      console.error("Error approving merchant:", e);
      toast.error("Failed to change merchant status to Live.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleDeclineSingle = async (id) => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const payload = {
        ids: [id],
        status: "disabled",
        reason: "Declined from details",
        silent: true,
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        setFullMerchantsList((prev) =>
          prev.map((m) =>
            m._id === id || m.id === id ? { ...m, status: "disabled" } : m,
          ),
        );
        setManualSortMap((prev) => ({ ...prev, [id]: Date.now() }));
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false); // Close modal
        setMerchantDetails(null); // Clear details
        toast.success("Merchant status changed to Disabled successfully!");
      }
    } catch (e) {
      console.error("Error declining merchant:", e);
      toast.error("Failed to change merchant status to Disabled.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleReviewStatus = async (merchantId, newStatus) => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    try {
      statusMutationLockRef.current = true;
      setStatusChangeLoading(true);
      const payload = {
        ids: [merchantId],
        status: newStatus,
        reason: "Status reviewed by admin",
        silent: true,
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload),
      )?.unwrap();
      if (statusPromise?.success) {
        const displayStatus = newStatus === "approved" ? "live" : newStatus;
        setManualSortMap((prev) => ({ ...prev, [merchantId]: Date.now() }));
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
        setMerchantDetails(null);
        setShowReviewModal(false);
        setFullMerchantsList((prev) =>
          prev.map((m) =>
            m._id === merchantId || m.id === merchantId
              ? { ...m, status: displayStatus }
              : m,
          ),
        );
        if (
          merchantDetails?._id === merchantId ||
          merchantDetails?.id === merchantId
        ) {
          setMerchantDetails((prev) =>
            prev ? { ...prev, status: displayStatus } : prev,
          );
        }
        toast.success(
          `Merchant status changed to ${displayStatus === "live" ? "Live" : "In-Progress"} successfully!`,
        );
      }
    } catch (e) {
      console.error("Error reviewing merchant status:", e);
      toast.error(`Failed to change merchant status to ${newStatus}.`);
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setShowReviewModal(false);
  };

  const handleStatusChangeRequest = async (status, merchant = null) => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    setTargetStatus(status);
    setStatusChangeTargetMerchant(merchant || merchantDetails || null);
    setShowStatusConfirm(true);
  };

  const handleStatusConfirm = async () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    const currentMerchant = statusChangeTargetMerchant || merchantDetails;
    if (!currentMerchant?._id || !targetStatus) {
      setStatusChangeTargetMerchant(null);
      setTargetStatus(null);
      setShowStatusConfirm(false);
      return;
    }

    try {
      statusMutationLockRef.current = true;
      setStatusChangeLoading(true);
      const payload = {
        ids: [currentMerchant._id],
        status: targetStatus,
        reason: `Status changed to ${targetStatus} by admin`,
        silent: true,
      };
      const response = await dispatch(
        approveOrRejectMerchant(payload),
      ).unwrap();
      if (response?.success) {
        const mid = currentMerchant?._id || currentMerchant?.id;
        const displayStatus =
          targetStatus === "approved" ? "live" : targetStatus;
        setFullMerchantsList((prev) =>
          prev.map((m) =>
            m._id === mid || m.id === mid ? { ...m, status: displayStatus } : m,
          ),
        );
        setManualSortMap((prev) => ({ ...prev, [mid]: Date.now() }));
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false); // Close modal on status change
        setMerchantDetails(null); // Clear details
        toast.success(
          `Merchant status changed to ${getMerchantStatusResultLabel(displayStatus)} successfully!`,
        );
        setShowStatusConfirm(false);
        setStatusChangeTargetMerchant(null);
        setTargetStatus(null);
      }
    } catch (error) {
      console.error("Error changing merchant status:", error);
      toast.error(
        `Failed to change merchant status to ${getMerchantStatusResultLabel(targetStatus)}.`,
      );
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleStatusCancel = () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    setShowStatusConfirm(false);
    setStatusChangeTargetMerchant(null);
    setTargetStatus(null);
  };

  const handleDeclineCancel = () => {
    setShowDeclineConfirm(false);
  };
  const handleApproveCancel = () => {
    setShowApprovalConfirm(false);
  };

  useEffect(() => {
    if (selected.length > 0) {
      setShowActionModal(true);
    } else {
      setShowActionModal(false);
    }
  }, [selected]);

  // Calculate count of selectable items for "Select All" checkbox
  const selectableCount = getSelectableOffers().length;
  const allSelectableSelected =
    selectableCount > 0 && selected.length === selectableCount;

  // Determine which bulk action buttons to show based on selected statuses
  const selectedStatuses = selected
    .map(
      (id) =>
        fullMerchantsList?.find((m) => m._id === id || m.id === id)?.status,
    )
    .filter(Boolean)
    .map((s) => s?.toLowerCase());
  const hasPendingSelected = selectedStatuses.includes("pending");
  // Treat both "live"/"approved" and "disabled"/"declined"/"rejected" as approved/declined for bulk actions
  // Exclude "deleted" merchants from bulk actions
  const hasApprovedDeclinedSelected = selectedStatuses.some(
    (status) =>
      status === "approved" ||
      status === "declined" ||
      status === "live" ||
      status === "disabled" ||
      status === "rejected",
  );

  // Show approve/decline buttons only if there are pending items selected
  const showApproveDecline = selected.length > 0 && hasPendingSelected;
  // Show move to pending only if there are approved/declined items selected
  const showMoveToPending = selected.length > 0 && hasApprovedDeclinedSelected;

  const handleMerchantDisable = async () => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    setOpenReasonBox(false);
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const togglePromise = await dispatch(
        toggleMerchantStatus({ id: selectedMerchant?._id, reason: reason }),
      ).unwrap();
      if (togglePromise?.success === true) {
        setStatusToggled(!statusToggled);
        setSelectedMerchant(null);
      }
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleCloseReject = () => {
    setSelectedMerchant(null);
    setOpenReasonBox(false);
  };

  const fetchMerchantDetails = async (merchantId) => {
    if (!merchantId) return;

    // We already set initial data in openMerchantPopup,
    // now we fetch additional background data (stores and possibly more details)
    try {
      // 1. Fetch stores/locations
      let storesData = [];
      try {
        const storesPromise = await dispatch(
          getFranchises({ merchant: merchantId, limit: 100 }),
        )?.unwrap();
        if (storesPromise?.success && storesPromise?.data) {
          storesData = storesPromise.data;
          // Optimistically update stores while wait for main profile
          setMerchantDetails((prev) => ({ ...prev, stores: storesData }));
        }
      } catch (err) {
        console.error("Error fetching merchant locations:", err);
      }

      // 2. Fetch full profile details
      try {
        const merchantDetailsPromise = await dispatch(
          getMerchantById({ id: merchantId, silent: true }),
        )?.unwrap();

        if (merchantDetailsPromise?.success === true) {
          setMerchantDetails((prev) => ({
            ...prev,
            ...merchantDetailsPromise?.data,
            // Prioritize storesData we just fetched, otherwise keep what was there
            stores: storesData?.length > 0 ? storesData : prev?.stores || [],
          }));
        }
      } catch (profileErr) {
        // Log but don't crash/clear if profile fetch fails - we still have table data
        console.warn("Detailed merchant profile fetch failed:", profileErr);
      }
    } catch (error) {
      console.error("Error in background detail fetch:", error);
    }
  };

  const openMerchantPopup = (merchant) => {
    if (!merchant) return;
    const mid = merchant?._id || merchant?.id;
    if (!mid) return;

    // Immediately set data from the table list so the modal isn't empty/loading
    setMerchantDetails(merchant);
    setIsMerchantDetailOpen(true);

    // Fetch full details (stores, etc.) in the background
    fetchMerchantDetails(mid);
  };

  useEffect(() => {
    if (!pendingMerchantModalId) return;

    const matchedMerchant =
      fullMerchantsList?.find(
        (merchant) =>
          merchant?._id === pendingMerchantModalId ||
          merchant?.id === pendingMerchantModalId,
      ) || null;

    if (matchedMerchant) {
      openMerchantPopup(matchedMerchant);
      navigate(location.pathname, { replace: true, state: {} });
      return;
    }

    if (!loading && Array.isArray(fullMerchantsList)) {
      setMerchantDetails({ _id: pendingMerchantModalId });
      setIsMerchantDetailOpen(true);
      fetchMerchantDetails(pendingMerchantModalId);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [
    pendingMerchantModalId,
    fullMerchantsList,
    loading,
    navigate,
    location.pathname,
  ]);

  const closeMerchantPopup = () => {
    setIsMerchantDetailOpen(false);
  };

  const handleDeleteMerchant = (id) => {
    setMerchantToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const deletePromise = await dispatch(
        deleteMerchantAdmin({ id: merchantToDelete }),
      )?.unwrap();
      if (deletePromise?.success === true) {
        setIsMerchantDetailOpen(false);
        getMerchantsData(searchQuery);
        toast.success("Merchant deleted successfully!");
      } else {
        // Handle case where API returns success: false with a message
        toast.error(deletePromise?.message || "Failed to delete merchant.");
      }
    } catch (error) {
      console.error("Error deleting merchant:", error);
      // Show specific error message from backend if available
      const errorMsg =
        error?.message ||
        error?.response?.data?.message ||
        "Failed to delete merchant.";
      toast.error(errorMsg);
    } finally {
      setShowDeleteConfirm(false);
      setMerchantToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setMerchantToDelete(null);
  };

  const handleOpenChangeLogoModal = (merchant) => {
    setMerchantForLogoChange(merchant);
    // Hide the View Details modal temporarily
    setIsMerchantDetailOpen(false);
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setShowChangeLogoModal(true);
    }, 100);
  };

  const handleCloseChangeLogoModal = () => {
    setShowChangeLogoModal(false);
    setMerchantForLogoChange(null);
    // Show the View Details modal back with animation
    setTimeout(() => {
      setIsMerchantDetailOpen(true);
    }, 100);
  };

  const handleLogoChangeSuccess = (newLogo) => {
    // Refresh merchant data after logo change
    getMerchantsData(searchQuery);

    // Optimistically update the exact merchantDetails state with the new logo
    if (merchantDetails?._id) {
      setMerchantDetails((prev) => ({ ...prev, logo: newLogo }));
      fetchMerchantDetails(merchantDetails._id);
    }
  };

  const handleOpenEditMerchantModal = (merchant) => {
    setMerchantForEdit(merchant);
    setIsMerchantDetailOpen(false);
    setTimeout(() => {
      setShowEditMerchantModal(true);
    }, 100);
  };

  const handleCloseEditMerchantModal = () => {
    setShowEditMerchantModal(false);
    setMerchantForEdit(null);
    setTimeout(() => {
      setIsMerchantDetailOpen(true);
    }, 100);
  };

  const handleEditMerchantSuccess = () => {
    getMerchantsData(searchQuery);
    if (merchantDetails?._id) {
      // Add a slight delay to ensure DB write propagation before refetching
      setTimeout(() => {
        fetchMerchantDetails(merchantDetails._id);
      }, 500);
    }
  };

  const handleSelectCsvLocation = (id) => {
    setSelectedCsvLocationIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handleBatchSelectCsvLocations = (locs, isSelected) => {
    if (isSelected) {
      setSelectedCsvLocationIds(locs.map((l) => l._id));
    } else {
      setSelectedCsvLocationIds([]);
    }
  };

  const handleCsvConfirm = async () => {
    if (selectedCsvLocationIds.length === 0) {
      toast.error("Please select at least one location.");
      return;
    }

    const selectedLocations = csvLocations.filter((loc) =>
      selectedCsvLocationIds.includes(loc._id),
    );
    setIsCsvSubmitting(true);

    try {
      const res = await dispatch(
        addFranchise({
          merchant: activeMerchantId,
          locations: selectedLocations,
        }),
      ).unwrap();
      if (res?.success) {
        toast.success(
          `${selectedLocations.length} location(s) added successfully`,
        );
        setCsvDrawerOpen(false);
        setCsvLocations([]);
        setSelectedCsvLocationIds([]);
        if (activeMerchantId) {
          setTimeout(() => {
            setIsMerchantDetailOpen(true);
            fetchMerchantDetails(activeMerchantId);
          }, 300);
        }
      }
    } catch (err) {
      console.error("CSV Confirm error:", err);
    } finally {
      setIsCsvSubmitting(false);
    }
  };

  return (
    <>
      {(loading === true || fundraiserLoading === true) && <Loader />}
      {infoClicked === true && (
        <DetailsPopup
          content={clickedOffer?.reason}
          handleClose={handleCloseInfo}
          icon={infoIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      {openReasonBox === true && (
        <RejectOfferPopup
          icon={crossIcon}
          content={
            "Could you please provide the reason for disabling this merchant?"
          }
          popupClassName={"w-[400px] sm:w-[500px] pb-4"}
          handleClose={handleCloseReject}
          setReason={setReason}
          handleOfferRejection={handleMerchantDisable}
        />
      )}
      {isMerchantDetailOpen && (
        <DetailsModal
          handleClose={closeMerchantPopup}
          content={
            <PopupContent
              merchantDetails={merchantDetails}
              onDelete={handleDeleteMerchant}
              onApprove={(id) => handleApproveSingle(id)}
              onDecline={(id) => handleDeclineSingle(id)}
              onReviewStatus={handleReviewStatus}
              onShowReviewModal={handleShowReviewModal}
              onChangeLogo={handleOpenChangeLogoModal}
              onEdit={handleOpenEditMerchantModal}
              onStatusChangeRequest={handleStatusChangeRequest}
              onAddLocation={() => {
                setLocationToEdit(null);
                setActiveMerchantId(merchantDetails?._id);
                setIsMerchantDetailOpen(false);
                setTimeout(() => setAddClicked(true), 100);
              }}
              onUploadCSV={() => {
                setCsvLocations([]);
                setSelectedCsvLocationIds([]);
                setActiveMerchantId(merchantDetails?._id);
                setIsMerchantDetailOpen(false);
                setTimeout(() => setCsvDrawerOpen(true), 100);
              }}
              onEditLocation={(store) => {
                setLocationToEdit(store);
                setActiveMerchantId(merchantDetails?._id);
                setIsMerchantDetailOpen(false);
                setTimeout(() => setAddClicked(true), 100);
              }}
            />
          }
          popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
        />
      )}
      {showApprovalConfirm && (
        <CancelPopup
          handleNo={handleApproveCancel}
          handleYes={handleApproveConfirm}
          heading="Approve Offers"
          content="Do you really want to approve all selected offers?"
          confirmation={true}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showDeclineConfirm && (
        <CancelPopup
          handleNo={handleDeclineCancel}
          handleYes={handleDeclineConfirm}
          heading="Decline Offers"
          content="Do you really want to decline all selected offers?"
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showStatusConfirm && (
        <CancelPopup
          handleNo={handleStatusCancel}
          handleYes={handleStatusConfirm}
          heading="Change Status"
          content={
            ["disabled", "declined", "rejected"].includes(
              String(targetStatus || "").toLowerCase(),
            ) &&
            String(
              (statusChangeTargetMerchant || merchantDetails)?.status || "",
            ).toLowerCase() === "approved" &&
            offerCount > 0
              ? `Are you sure you want to disable this merchant? By moving to "Disabled", ${offerCount} live offer${offerCount > 1 ? "s" : ""} of this merchant will be removed from the App.`
              : `Are you sure you want to ${getMerchantStatusActionLabel(targetStatus).toLowerCase()} this merchant?`
          }
          confirmation={String(targetStatus || "").toLowerCase() === "approved"}
          popupClassName="w-[300px] sm:w-[420px] h-[240px] sm:h-[230px]"
          confirmDisabled={statusChangeLoading}
          cancelDisabled={statusChangeLoading}
          confirmLabel={statusChangeLoading ? "Updating..." : "Confirm"}
        />
      )}
      {showDeleteConfirm && (
        <DeleteConfirmationModal
          isOpen={showDeleteConfirm}
          onClose={() => setShowDeleteConfirm(false)}
          onConfirm={handleDeleteConfirm}
          itemName="Merchant"
        />
      )}
      {showChangeLogoModal && merchantForLogoChange && (
        <ChangeLogoModal
          merchantDetails={merchantForLogoChange}
          onClose={handleCloseChangeLogoModal}
          onSuccess={handleLogoChangeSuccess}
        />
      )}
      {showEditMerchantModal && merchantForEdit && (
        <EditMerchantModal
          merchantDetails={merchantForEdit}
          onClose={handleCloseEditMerchantModal}
          onSuccess={handleEditMerchantSuccess}
        />
      )}
      <div className="flex flex-col sm:flex-row justify-between col-span-12 gap-4">
        <BreadCrumsHeader heading="Merchant List" items={items} />
        <div className="flex gap-3 items-center">
          {/* In-Progress Merchants button removed as per request to merge lists */}
        </div>
      </div>
      <div className="w-full flex justify-between items-center mt-6 gap-3">
        <SearchBar
          parentDivClass="w-full sm:w-[60%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative w-full"
          inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px]"
          placeholder="Search"
          value={searchInput}
          handleChange={(e) => handleSearchChange(e.target.value)}
          onClear={() => handleSearchChange("")}
          loading={searching}
        />
        <div className="flex items-center gap-2">
          <FilterButton
            activeCount={activeCount}
            isOpen={open}
            onClick={() => setOpen(true)}
          />
        </div>
        <MuiDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
          ModalProps={{ keepMounted: true }}
          TransitionComponent={Slide}
          SlideProps={{
            appear: true,
            timeout: { enter: 700, exit: 500 },
            easing: {
              enter: "cubic-bezier(0.22, 1, 0.36, 1)",
              exit: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
          }}
          PaperProps={{
            sx: {
              width: { xs: "100%", sm: "400px" },
              padding: "0",
              height: "100%",
            },
          }}
        >
          <FilterPanel
            filterData={filterData}
            selections={selections}
            appliedSelections={filterParams}
            handleApply={handleApply}
            handleCancel={handleCancel}
            handleReset={handleReset}
            handleSelectionChange={handleSelectionChange}
            applyDisabled={isMerchantCustomDateIncomplete}
            style={{ maxHeight: "unset" }}
          />
        </MuiDrawer>
      </div>

      <ActiveFilterBar
        chips={activeFilterChips}
        onRemove={handleRemoveFilter}
        onClearAll={handleReset}
      />
      <div id="merchant-list-container" className="col-span-12 mt-4">
        {/* Desktop Table View */}
        <TableContainer
          style={{ width: "100%", overflowX: "auto" }}
          className="hidden md:block"
        >
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns
                  .filter(
                    (column) =>
                      !(
                        filterParams.status === "in-process" &&
                        column.name === "Actions"
                      ),
                  )
                  .map((column) => {
                    return (
                      <TruncatedTableCell
                        key={column.name}
                        className="!text-[#FFFFFF]"
                        textClassName="!text-[#FFFFFF] !font-[700]"
                        title={column.name}
                        maxChars={14}
                      >
                        {column.name}
                      </TruncatedTableCell>
                    );
                  })}
              </TableRow>
            </TableHead>

            <TableBody>
              {displayedMerchants &&
                displayedMerchants?.length > 0 &&
                displayedMerchants?.map((merchant, index) => {
                  const isItemSelected = isSelected(merchant._id);
                  const itemSelectable = isSelectable(merchant.status);
                  return (
                    <TableRow
                      key={merchant._id}
                      className="h-[50px]"
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor:
                          (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                      }}
                    >
                      <TruncatedTableCell className="max-w-[50px]">
                        {(currentPage - 1) * 10 + index + 1}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[120px]">
                        {merchant?.businessName || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell
                        className="max-w-[120px]"
                        title={
                          merchant?.createdAt ||
                          merchant?.created_at ||
                          merchant?.notifiedAt
                        }
                      >
                        {separateDateTimeAndConvertToLocale(
                          merchant?.createdAt ||
                            merchant?.created_at ||
                            merchant?.notifiedAt,
                        )?.localDate || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[140px]">
                        {merchant?.user?.email || merchant?.email || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[120px]">
                        {merchant?.contactPersonNumber || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[180px]">
                        {merchant?.address || "N/A"}
                      </TruncatedTableCell>
                      <TableCell className="max-w-[130px]">
                        {(() => {
                          const rawStatus = merchant?.status || "";
                          const s = rawStatus.toLowerCase();

                          // Format status: capitalize first letter, replace underscores with spaces
                          const formatStatus = (val) => {
                            if (!val) return "N/A";
                            return val
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase());
                          };

                          const formattedStatus = formatStatus(rawStatus);
                          const isDeleted = s === "deleted";
                          const isInProgressState = isInProcess(merchant);

                          // Determine color scheme based on actual status
                          let bgColor, borderColor, dotColor, label, width;

                          if (
                            isInProgressState ||
                            s === "pending" ||
                            s === "in-progress" ||
                            s === "in_progress" ||
                            s === "accepted" ||
                            s === "completed"
                          ) {
                            // In-Progress states
                            bgColor = "#FFF1D6";
                            borderColor = "#FFC961";
                            label = "In-Progress";
                            width = "110px";

                            return (
                              <Tooltip
                                title="In-Progress"
                                arrow
                                placement="top"
                              >
                                <div
                                  className="flex items-center justify-center gap-2 h-[26px] px-2.5 rounded-full border-[0.5px] select-none"
                                  style={{
                                    background: bgColor,
                                    borderColor,
                                    width,
                                  }}
                                >
                                  <svg
                                    width="11"
                                    height="12"
                                    viewBox="0 0 11 12"
                                    fill="none"
                                    style={{ display: "block" }}
                                  >
                                    <path
                                      d="M10.2083 1.16667H9.33333V1.72322C9.33333 2.55097 8.97616 3.33541 8.35981 3.87369L8.23334 3.97738L6.02875 5.6875L8.23334 7.3976L8.35981 7.50132C8.97616 8.03962 9.33333 8.82403 9.33333 9.65177V10.2083H10.2083V11.375H0V10.2083H0.875V9.65177C0.875 8.76902 1.28139 7.93596 1.97502 7.3976L4.17906 5.6875L1.97502 3.97738C1.28139 3.43906 0.875 2.60598 0.875 1.72322V1.16667H0V0H10.2083V1.16667ZM2.00293 1.16667V1.72322C2.00293 2.25296 2.24688 2.75319 2.66317 3.07617L5.10417 4.96971L7.54518 3.07617L7.62148 3.01294C7.99114 2.68998 8.2054 2.21972 8.2054 1.72322V1.16667H2.00293Z"
                                      fill="#FFC961"
                                    />
                                  </svg>
                                  <p
                                    className="text-[12px] font-[400]"
                                    style={{ color: "#303033" }}
                                  >
                                    In-Progress
                                  </p>
                                </div>
                              </Tooltip>
                            );
                          }

                          if (isDeleted) {
                            bgColor = "rgba(236,130,110,0.15)";
                            borderColor = "#EC826E";
                            label = "Deleted";
                            width = "110px";

                            return (
                              <Tooltip title="Deleted" arrow placement="top">
                                <div
                                  className="flex items-center justify-start gap-2 h-[26px] px-2.5 rounded-full border-[0.5px] select-none"
                                  style={{
                                    backgroundColor: bgColor,
                                    borderColor,
                                    width,
                                  }}
                                >
                                  <div
                                    className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                    style={{ backgroundColor: "#EC826E" }}
                                  >
                                    {/* Swap icons: Deleted uses the previous Disabled icon */}
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="8 6 14 14"
                                      fill="none"
                                      style={{ display: "block" }}
                                    >
                                      <path
                                        d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                  <span className="text-[12px] font-[400] font-poppins text-[#303033]">
                                    Deleted
                                  </span>
                                </div>
                              </Tooltip>
                            );
                          }

                          // For approved/live status
                          if (
                            s === "approved" ||
                            s === "live" ||
                            s === "active"
                          ) {
                            bgColor = "rgba(80,205,137,0.15)";
                            borderColor = "#50CD89";
                            dotColor = "#50CD89";
                            label = formattedStatus;
                            width = "110px";
                          }
                          // For declined/disabled/rejected status
                          else if (
                            s === "declined" ||
                            s === "disabled" ||
                            s === "rejected"
                          ) {
                            bgColor = "rgba(236,130,110,0.15)";
                            borderColor = "#EC826E";
                            dotColor = "#EC826E";
                            label = formattedStatus;
                            width = "110px";
                          }
                          // Default for any other status
                          else {
                            bgColor = "rgba(150,150,150,0.15)";
                            borderColor = "#999";
                            dotColor = "#999";
                            label = formattedStatus;
                            width = "110px";
                          }

                          return (
                            <Dropdown
                              menu={{
                                items: [
                                  s !== "approved" &&
                                    s !== "live" &&
                                    s !== "active" && {
                                      key: "live",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                            <svg
                                              width="10"
                                              height="10"
                                              viewBox="8 6 14 14"
                                              fill="none"
                                            >
                                              <path
                                                d="M12 13.6667L14.3333 16L19 11"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Live
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleStatusChangeRequest(
                                          "approved",
                                          merchant,
                                        ),
                                    },
                                  s !== "declined" &&
                                    s !== "disabled" &&
                                    s !== "rejected" && {
                                      key: "disabled",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            <svg
                                              width="10"
                                              height="10"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="white"
                                              strokeWidth="4"
                                              strokeLinecap="round"
                                            >
                                              <path d="M7 12h10" />
                                            </svg>
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Disable
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleStatusChangeRequest(
                                          "disabled",
                                          merchant,
                                        ),
                                    },
                                  !isInProgressState &&
                                    s !== "deleted" && {
                                      key: "deleted",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            <svg
                                              width="10"
                                              height="10"
                                              viewBox="8 6 14 14"
                                              fill="none"
                                            >
                                              <path
                                                d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                                fill="white"
                                              />
                                            </svg>
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Delete
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleDeleteMerchant(
                                          merchant._id || merchant.id,
                                        ),
                                    },
                                ].filter(Boolean),
                              }}
                              trigger={["click"]}
                              placement="bottomLeft"
                              disabled={
                                isDeleted ||
                                isInProgressState ||
                                statusChangeLoading ||
                                statusMutationLockRef.current
                              }
                            >
                              <span className="inline-flex">
                                <Tooltip title={label} arrow placement="top">
                                  <div
                                    className="cursor-pointer flex items-center h-[26px] pl-2.5 pr-2 rounded-full border-[0.5px] transition-all hover:opacity-90 select-none"
                                    style={{
                                      backgroundColor: bgColor,
                                      borderColor,
                                      width,
                                      cursor:
                                        isDeleted ||
                                        isInProgressState ||
                                        statusChangeLoading ||
                                        statusMutationLockRef.current
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <div
                                      className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                      style={{ backgroundColor: dotColor }}
                                    >
                                      {s === "approved" ||
                                      s === "live" ||
                                      s === "active" ? (
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="8 6 14 14"
                                          fill="none"
                                          style={{ display: "block" }}
                                        >
                                          <path
                                            d="M12 13.6667L14.3333 16L19 11"
                                            stroke="white"
                                            strokeWidth="2.0"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      ) : s === "disabled" ? (
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          style={{ display: "block" }}
                                        >
                                          <path d="M7 12h10" />
                                        </svg>
                                      ) : (
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="8 6 14 14"
                                          fill="none"
                                          style={{ display: "block" }}
                                        >
                                          <path
                                            d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                            fill="white"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                    <span className="text-[12px] font-[400] ml-2 font-poppins text-[#303033] truncate flex-1">
                                      {label}
                                    </span>
                                    <div className="ml-2 flex items-center flex-shrink-0">
                                      <svg
                                        width="7"
                                        height="4"
                                        viewBox="0 0 10 6"
                                        fill="none"
                                      >
                                        <path
                                          d="M1 1.5L5 5.5L9 1.5"
                                          stroke="#303033"
                                          strokeWidth="1.8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </Tooltip>
                              </span>
                            </Dropdown>
                          );
                        })()}
                      </TableCell>
                      <TableCell className="max-w-[130px]">
                        <button
                          className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                          onClick={() => openMerchantPopup(merchant)}
                        >
                          <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                            View Details
                          </span>
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })}

              {!loading &&
                !searching &&
                displayedMerchants &&
                displayedMerchants.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={
                        columns.filter(
                          (column) =>
                            !(
                              filterParams.status === "in-process" &&
                              column.name === "Actions"
                            ),
                        ).length
                      }
                      align="center"
                      className="!border-b-0 !p-0"
                    >
                      <TableEmptyState itemName="Merchant" />
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile Card View */}
        <div className="block md:hidden space-y-4">
          {displayedMerchants &&
            displayedMerchants?.length > 0 &&
            displayedMerchants?.map((merchant, index) => (
              <div
                key={merchant._id}
                className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-[16px] font-[600] text-[#303030] font-poppins truncate max-w-[200px]">
                      {merchant?.businessName || "N/A"}
                    </h3>
                    <p className="text-[12px] font-[400] text-[#767676] font-poppins">
                      {merchant?.user?.email || merchant?.email || "N/A"}
                    </p>
                  </div>
                  {(() => {
                    const rawStatus = merchant?.status || "";
                    const s = rawStatus.toLowerCase();

                    // Format status: capitalize first letter, replace underscores with spaces
                    const formatStatus = (val) => {
                      if (!val) return "N/A";
                      return val
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase());
                    };

                    const formattedStatus = formatStatus(rawStatus);
                    const isDeleted = s === "deleted";
                    const isInProgressState = isInProcess(merchant);

                    // Determine color scheme based on actual status
                    let bgColor, borderColor, dotColor, label, width;

                    if (
                      isInProgressState ||
                      s === "pending" ||
                      s === "in-progress" ||
                      s === "in_progress" ||
                      s === "accepted" ||
                      s === "completed"
                    ) {
                      bgColor = "#FFF1D6";
                      borderColor = "#FFC961";
                      label = "In-Progress";
                      width = "110px";

                      return (
                        <Tooltip title="In-Progress" arrow placement="top">
                          <div
                            className="flex items-center justify-center gap-2 h-[26px] px-2.5 rounded-full border-[0.5px] select-none"
                            style={{ background: bgColor, borderColor, width }}
                          >
                            <svg
                              width="11"
                              height="12"
                              viewBox="0 0 11 12"
                              fill="none"
                              style={{ display: "block" }}
                            >
                              <path
                                d="M10.2083 1.16667H9.33333V1.72322C9.33333 2.55097 8.97616 3.33541 8.35981 3.87369L8.23334 3.97738L6.02875 5.6875L8.23334 7.3976L8.35981 7.50132C8.97616 8.03962 9.33333 8.82403 9.33333 9.65177V10.2083H10.2083V11.375H0V10.2083H0.875V9.65177C0.875 8.76902 1.28139 7.93596 1.97502 7.3976L4.17906 5.6875L1.97502 3.97738C1.28139 3.43906 0.875 2.60598 0.875 1.72322V1.16667H0V0H10.2083V1.16667ZM2.00293 1.16667V1.72322C2.00293 2.25296 2.24688 2.75319 2.66317 3.07617L5.10417 4.96971L7.54518 3.07617L7.62148 3.01294C7.99114 2.68998 8.2054 2.21972 8.2054 1.72322V1.16667H2.00293Z"
                                fill="#FFC961"
                              />
                            </svg>
                            <p
                              className="text-[12px] font-[400]"
                              style={{ color: "#303033" }}
                            >
                              In-Progress
                            </p>
                          </div>
                        </Tooltip>
                      );
                    }
                    if (isDeleted) {
                      bgColor = "rgba(236,130,110,0.15)";
                      borderColor = "#EC826E";
                      label = "Deleted";
                      width = "110px";

                      return (
                        <Tooltip title="Deleted" arrow placement="top">
                          <div
                            className="flex items-center justify-start gap-2 h-[26px] px-2.5 rounded-full border-[0.5px] select-none"
                            style={{
                              backgroundColor: bgColor,
                              borderColor,
                              width,
                            }}
                          >
                            <div
                              className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                              style={{ backgroundColor: "#EC826E" }}
                            >
                              {/* Swap icons: Deleted uses the previous Disabled icon */}
                              <svg
                                width="12"
                                height="12"
                                viewBox="8 6 14 14"
                                fill="none"
                                style={{ display: "block" }}
                              >
                                <path
                                  d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <span className="text-[12px] font-[400] font-poppins text-[#303033]">
                              Deleted
                            </span>
                          </div>
                        </Tooltip>
                      );
                    }

                    // For approved/live status
                    if (s === "approved" || s === "live" || s === "active") {
                      bgColor = "rgba(80,205,137,0.15)";
                      borderColor = "#50CD89";
                      dotColor = "#50CD89";
                      label = formattedStatus;
                      width = "110px";
                    }
                    // For declined/disabled/rejected status
                    else if (
                      s === "declined" ||
                      s === "disabled" ||
                      s === "rejected"
                    ) {
                      bgColor = "rgba(236,130,110,0.15)";
                      borderColor = "#EC826E";
                      dotColor = "#EC826E";
                      label = formattedStatus;
                      width = "110px";
                    }
                    // Default for any other status
                    else {
                      bgColor = "rgba(150,150,150,0.15)";
                      borderColor = "#999";
                      dotColor = "#999";
                      label = formattedStatus;
                      width = "110px";
                    }

                    return (
                      <Dropdown
                        menu={{
                          items: [
                            s !== "approved" &&
                              s !== "live" &&
                              s !== "active" && {
                                key: "live",
                                label: (
                                  <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                    <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="8 6 14 14"
                                        fill="none"
                                      >
                                        <path
                                          d="M12 13.6667L14.3333 16L19 11"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                    <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                      Live
                                    </span>
                                  </div>
                                ),
                                onClick: () =>
                                  handleStatusChangeRequest(
                                    "approved",
                                    merchant,
                                  ),
                              },
                            s !== "declined" &&
                              s !== "disabled" &&
                              s !== "rejected" && {
                                key: "disabled",
                                label: (
                                  <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                    <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="white"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                      >
                                        <path d="M7 12h10" />
                                      </svg>
                                    </div>
                                    <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                      Disable
                                    </span>
                                  </div>
                                ),
                                onClick: () =>
                                  handleStatusChangeRequest(
                                    "disabled",
                                    merchant,
                                  ),
                              },
                            !isInProgressState &&
                              s !== "deleted" && {
                                key: "deleted",
                                label: (
                                  <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                    <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="8 6 14 14"
                                        fill="none"
                                      >
                                        <path
                                          d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                          fill="white"
                                        />
                                      </svg>
                                    </div>
                                    <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                      Delete
                                    </span>
                                  </div>
                                ),
                                onClick: () =>
                                  handleDeleteMerchant(
                                    merchant._id || merchant.id,
                                  ),
                              },
                          ].filter(Boolean),
                        }}
                        trigger={["click"]}
                        placement="bottomLeft"
                      >
                        <span className="inline-flex">
                          <Tooltip title={label} arrow placement="top">
                            <div
                              className="cursor-pointer flex items-center h-[26px] pl-2.5 pr-2 rounded-full border-[0.5px] transition-all hover:opacity-90 select-none"
                              style={{
                                backgroundColor: bgColor,
                                borderColor,
                                width,
                              }}
                            >
                              <div
                                className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                style={{ backgroundColor: dotColor }}
                              >
                                {s === "approved" ||
                                s === "live" ||
                                s === "active" ? (
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="8 6 14 14"
                                    fill="none"
                                    style={{ display: "block" }}
                                  >
                                    <path
                                      d="M12 13.6667L14.3333 16L19 11"
                                      stroke="white"
                                      strokeWidth="2.0"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ) : s === "disabled" ? (
                                  /* Swap icons: Disabled uses the previous Deleted icon */
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    style={{ display: "block" }}
                                  >
                                    <path d="M7 12h10" />
                                  </svg>
                                ) : (
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="8 6 14 14"
                                    fill="none"
                                    style={{ display: "block" }}
                                  >
                                    <path
                                      d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
                                      fill="white"
                                    />
                                  </svg>
                                )}
                              </div>
                              <span className="text-[12px] font-[400] ml-2 font-poppins text-[#303033] truncate flex-1">
                                {label}
                              </span>
                              <div className="ml-2 flex items-center flex-shrink-0">
                                <svg
                                  width="7"
                                  height="4"
                                  viewBox="0 0 10 6"
                                  fill="none"
                                >
                                  <path
                                    d="M1 1.5L5 5.5L9 1.5"
                                    stroke="#303033"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                          </Tooltip>
                        </span>
                      </Dropdown>
                    );
                  })()}
                </div>

                <div className="grid grid-cols-2 gap-2 text-[13px] font-poppins text-[#303030]">
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">
                      Joined Date
                    </span>
                    <span className="truncate">
                      {separateDateTimeAndConvertToLocale(
                        merchant?.createdAt ||
                          merchant?.created_at ||
                          merchant?.notifiedAt,
                      )?.localDate || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Contact</span>
                    <span className="truncate">
                      {merchant?.contactPersonNumber || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col col-span-2 mt-1">
                    <span className="text-[#8C8C8C] text-[11px]">Address</span>
                    <span className="truncate">
                      {merchant?.address || "N/A"}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-2">
                  <button
                    className="flex-1 flex justify-center items-center border border-[#00ADEF] rounded-[6px] py-2 bg-[#F0FBFF] hover:bg-[#E0F7FA] transition-colors"
                    onClick={() => openMerchantPopup(merchant)}
                  >
                    <span className="font-[600] text-[13px] text-[#00ADEF] font-poppins">
                      View Details
                    </span>
                  </button>
                </div>
              </div>
            ))}
          {!loading &&
            !searching &&
            (!displayedMerchants || displayedMerchants.length === 0) && (
              <TableEmptyState itemName="Merchant" />
            )}
        </div>

        {displayedMerchants && displayedMerchants.length > 0 && (
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}

        {/* {showActionModal && (
          <div
            className="fixed bottom-16 left-[57%] transform -translate-x-1/2 bg-white rounded-[6px] px-4 h-[60px] flex items-center gap-4 z-50 text-[14px] font-[600] text-[#303030] border border-[#0000001A]"
            style={{ boxShadow: "0px 4px 20px 0px #00000029" }}
          >
            <div className="flex items-center gap-2">
              <span className="!text-[12px] !font-[500] !text-[#000000] border border-[#2A35484D] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center">
                {selected.length}
              </span>
              <span className="!font-[500]">Selected</span>
            </div>
            <div className="flex items-center gap-16">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedGreyIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                  <span className="whitespace-nowrap !font-[500]">
                    Select All
                  </span>
                </div>
                {showApproveDecline && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className="bg-[#00ADEF] text-white h-[38px] whitespace-nowrap pl-4 pr-8 py-1 rounded-[6px] flex items-center gap-2"
                    >
                      <img
                        src={whiteTick}
                        alt="tick"
                        className="h-[16px] w-[16px]"
                      />
                      Approve Merchants
                    </button>
                    <button
                      onClick={handleBulkDecline}
                      className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                    >
                      Decline Merchants
                    </button>
                  </>
                )}
                {showMoveToPending && (
                  <button
                    onClick={handleBulkPending}
                    className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                  >
                    Move to Pending
                  </button>
                )}
              </div>
              <button
                onClick={() => setSelected([])}
                className="w-[10px] h-[10px]"
              >
                <img src={closeIcon} alt="Close" className="w-full h-full" />
              </button>
            </div>
          </div>
        )} */}

        {/* Review Status Modal */}
        {/* {showReviewModal && (
          <div className="popup-container" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl border border-[#00ADEF]">
              <h3 className="text-lg font-semibold mb-4 text-center">Review Status</h3>
              <p className="text-gray-600 mb-6 text-center">
                Are you sure you want to change the status from{" "}
                <span className="font-semibold capitalize">{merchantDetails?.status}</span> to{" "}
                <span className="font-semibold">Pending</span>?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleCloseReviewModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleReviewStatus(merchantDetails?._id, "pending")}
                  className="flex-1 px-4 py-2 bg-[#00ADEF] text-white rounded-md hover:bg-[#0088CC]"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div>
      {/* Add Location Drawer */}
      <Drawer
        placement="right"
        onClose={() => {
          setAddClicked(false);
          setLocationToEdit(null);
          setIsMerchantDetailOpen(true);
        }}
        open={addClicked}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer add-location-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: "none" }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div
            className="close-icon-wrapper"
            onClick={() => {
              setAddClicked(false);
              setLocationToEdit(null);
              setIsMerchantDetailOpen(true);
            }}
          >
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">
              {locationToEdit
                ? "Edit Store Location for "
                : "Add New Store Location for "}
              <span className="text-[#00ADEF]">
                {merchantDetails?.businessName}
              </span>
            </h2>
            <p className="drawer-subtitle">
              {locationToEdit
                ? "Update the details for this store location."
                : "Fill in the required details to create a new store location."}
            </p>
          </div>
        </div>
        <AddNewLocation
          allStores={false}
          setLocations={() => {}}
          setSelectedLocations={() => {}}
          setSelectedLocationIds={() => {}}
          setLocationNames={() => {}}
          selectedMerchant={merchantDetails}
          editData={locationToEdit}
          onSuccess={() => {
            setAddClicked(false);
            setLocationToEdit(null);
            if (activeMerchantId) {
              setTimeout(() => {
                setIsMerchantDetailOpen(true);
                fetchMerchantDetails(activeMerchantId);
              }, 300);
            }
          }}
          isDrawer={true}
        />
      </Drawer>

      {/* Upload CSV Drawer */}
      <Drawer
        placement="right"
        onClose={() => {
          setCsvDrawerOpen(false);
          setIsMerchantDetailOpen(true);
        }}
        open={csvDrawerOpen}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer csv-upload-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: "none" }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div
            className="close-icon-wrapper"
            onClick={() => {
              setCsvDrawerOpen(false);
              setIsMerchantDetailOpen(true);
            }}
          >
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">
              Upload Locations via CSV for{" "}
              <span className="text-[#00ADEF]">
                {merchantDetails?.businessName}
              </span>
            </h2>
            <p className="drawer-subtitle">
              Quickly add multiple store locations by uploading a CSV file.
            </p>
          </div>
        </div>
        <UploadCSVDrawer
          onClose={() => {
            setCsvDrawerOpen(false);
            setCsvLocations([]);
            setSelectedCsvLocationIds([]);
            setIsMerchantDetailOpen(true);
          }}
          csvLocations={csvLocations}
          selectedLocationIds={selectedCsvLocationIds}
          onSelectionChange={handleSelectCsvLocation}
          onBatchSelectionChange={handleBatchSelectCsvLocations}
          onConfirm={handleCsvConfirm}
          isSubmitting={isCsvSubmitting}
          onClear={() => {
            setCsvLocations([]);
            setSelectedCsvLocationIds([]);
          }}
          onUploadSuccess={(event) => {
            const file = event?.target?.files?.[0];
            if (!file) return;
            const isCSV = file.name.toLowerCase().endsWith(".csv");
            if (!isCSV) {
              toast.error("Only .csv files are allowed!");
              return;
            }
            const reader = new FileReader();
            reader.onload = (e) => {
              const text = e.target.result;
              const lines = text.split(/\r?\n/).filter((l) => l.trim() !== "");
              if (lines.length < 2) {
                toast.error("CSV must have headers and at least one row.");
                return;
              }
              const splitLine = (line) => {
                const m = line.trim().match(/("[^"]*"|[^,]+)(?=,|$)/g);
                return m ? m.map((x) => x.replace(/^"|"$/g, "").trim()) : [];
              };
              const headers = splitLine(lines[0]).map((h) =>
                h.toLowerCase().replace(/\r/g, ""),
              );
              const days = [
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
              ];
              const data = lines
                .slice(1)
                .map((line, idx) => {
                  const vals = splitLine(line).map((v) => v.replace(/\r/g, ""));
                  const row = {};
                  headers.forEach((k, i) => {
                    row[k] = vals[i] || "";
                  });
                  const tradingHours = days.map((day) => ({
                    day,
                    openTime: row[`${day}_open`] || "",
                    closeTime: row[`${day}_close`] || "",
                  }));
                  return {
                    name: row["name"] || "",
                    email: row["email"] || "",
                    phone: String(row["phone"] || "").replace(/\D/g, ""),
                    address: row["address"] || "",
                    tradingHours,
                    googlePlaceId: row["googleplaceid"] || null,
                    _id: `temp_${Date.now()}_${idx}`,
                  };
                })
                .filter((r) => r.name && (r.address || r.googlePlaceId));
              if (data.length > 0) {
                setCsvLocations(data);
                setSelectedCsvLocationIds(data.map((d) => d._id));
                toast.success(`${data.length} locations parsed from CSV.`);
              }
            };
            reader.readAsText(file);
          }}
          sampleFileUrl="/sample-locations.csv"
        />
      </Drawer>
    </>
  );
};

export default AdminMerchantList;
